<!-- BatchDeleteCouponReservationForm.vue -->
 <script setup>
import { computed, ref } from "vue";
import { useCouponReservationStore } from "@/stores/useCouponReservationStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const emit = defineEmits(["close", "refresh", "notify"]);
const store = useCouponReservationStore();

// IDs selecionados APENAS da página atual — mesmo padrão do BatchDeleteCouponForm.
const selectedIdsOnCurrentPage = computed(() => {
  const idsOnPage = store.reservations.map((r) => r.couponReservationId);
  return store.selectedReservationIds.filter((id) => idsOnPage.includes(id));
});

const selectedCount = computed(() => selectedIdsOnCurrentPage.value.length);

const frozenCount = ref(selectedCount.value);
if (!frozenCount.value || frozenCount.value < 1) frozenCount.value = 1;

const messageTitle = computed(() => {
  if (frozenCount.value === 1)
    return "Tem certeza que deseja apagar a reserva selecionada?";
  return `Tem certeza que deseja apagar as ${frozenCount.value} reservas selecionadas?`;
});

function buildBatchDeleteError(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao excluir as reservas."
  );
}

async function onConfirmBatchDelete() {
  try {
    await store.deleteSelectedCouponReservations();

    emit("notify", {
      type: "success",
      message:
        frozenCount.value === 1
          ? "Reserva apagada com sucesso."
          : "Reservas apagadas com sucesso.",
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildBatchDeleteError(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Reservas em Lote"
    :messageTitle="messageTitle"
    messageSubtitle="As reservas selecionadas serão apagadas. Reservas já consumidas fazem parte do histórico financeiro das assinaturas — ao apagá-las, esse rastro será perdido. Esta ação não pode ser desfeita."
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmBatchDelete"
    @close="emit('close')"
  />
</template>